import { Injectable } from "@angular/core";
import {
  RouteReuseStrategy,
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
  ParamMap,
} from "@angular/router";
import { TabCacheService } from '../tabs/tab-cache.service';

@Injectable({
  providedIn: "root",
})
export class TabRouteReuseStrategyService implements RouteReuseStrategy {

  constructor(private tabService: TabCacheService) {}

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    const tab = this.getTab(route, false);

    return !!tab && tab.storeable;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    const tab = this.getTab(route, false);

    if (tab) {
      tab.handle = handle;
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const tab = this.getTab(route, false);

    return tab && !!tab.handle;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    const tab = this.getTab(route, false);

    if (tab) {
      return tab.handle;
    } else {
      return null;
    }
  }

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    const futureTab = this.getTab(future, true, true);
    const currentTab = this.getTab(curr, true, true);
    if (futureTab && currentTab) {
      return futureTab.id === currentTab.id;
    } else {
      return false;
    }
  }

  paramsSame(params1: ParamMap, params2: ParamMap) {
    return this.compareObjects(params1, params2);
  }

  getTabId(route: ActivatedRouteSnapshot, searchDescendants = false, searchQueryParams = false) {
    if (searchQueryParams && route.queryParamMap.get("tabId")) {
      return route.queryParamMap.get("tabId");
    } else if (route.data.tabId) {
      return route.data.tabId;
    } else if (route.data.tab) {
      return route.data.tab.id;
    } else if (searchDescendants && route.firstChild) {
      return this.getTabId(route.firstChild, true);
    } else {
      return null;
    }
  }

  getTab(route: ActivatedRouteSnapshot, searchDescendants = false, searchQueryParams = false) {
    const tabId = this.getTabId(route, searchDescendants, searchQueryParams);
    if (tabId) {
      return this.getTabById(tabId);
    } else {
      return null;
    }
  }

  getTabById(tabId) {
    return this.tabService.getTabById(tabId);
  }

  private compareObjects(base: any, compare: any): boolean {

    // loop through all properties in base object
    for (const baseProperty in base) {

        // determine if comparrison object has that property, if not: return false
        if (compare.hasOwnProperty(baseProperty)) {
            switch (typeof base[baseProperty]) {
                // if one is object and other is not: return false
                // if they are both objects, recursively call this comparison function
                case 'object':
                    if ( typeof compare[baseProperty] !== 'object' || !this.compareObjects(base[baseProperty], compare[baseProperty]) ) { return false; } break;
                // if one is function and other is not: return false
                // if both are functions, compare function.toString() results
                case 'function':
                    if ( typeof compare[baseProperty] !== 'function' || base[baseProperty].toString() !== compare[baseProperty].toString() ) { return false; } break;
                // otherwise, see if they are equal using coercive comparison
                default:
                    if ( base[baseProperty] !== compare[baseProperty] ) { return false; }
            }
        } else {
            return false;
        }
    }

    // returns true only after false HAS NOT BEEN returned through all loops
    return true;
}
}
